import React, {ReactNode, Children, Fragment} from 'react';
import Text from '../../common/component/Text';

interface IProps {
  title?: string;
  children: ReactNode;
  className?: string;
}

export default function SettingItemWrapperV4({
  title,
  children,
  className,
}: IProps) {
  const childrenToArray = Children.toArray(children);

  return (
    <div className={cn(className)}>
      {title && <Text className="s13-medium-grey06 px-18 mb-8">{title}</Text>}
      <div className="w-full rounded-12 overflow-hidden bg-grey-01 light:!bg-white">
        {childrenToArray.map((child, idx) => (
          <Fragment key={idx}>
            <div className="mx-18 border-t border-solid border-grey-03 first:border-t-0" />
            {child}
          </Fragment>
        ))}
      </div>
    </div>
  );
}
